import React from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { validationSchemaRectificativaTotal } from './RectificativaTotalSchema';
import { LoadingButton } from '@mui/lab';
import { useDispatch } from 'react-redux';
import { startCreateRectificativaTotal } from '@/redux/actions/facturasService';
import { useParams } from '@reach/router';

interface RectificativaTotalValues {
  ConceptoRectificacionACero: string;
}

interface Props {
  toggleDialogClose: () => void;
}

export const RectificativaTotalForm = ({ toggleDialogClose }: Props) => {
  const dispatch = useDispatch();
  const params = useParams();

  const PkVentas = params.PkVentas;

  const initialValues: RectificativaTotalValues = {
    ConceptoRectificacionACero: '',
  };

  const handleSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);
    dispatch(
      startCreateRectificativaTotal(PkVentas, values, () => {
        toggleDialogClose();
        setSubmitting(false);
      }),
    );
  };

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchemaRectificativaTotal} onSubmit={handleSubmit}>
      {({ values, handleChange, handleBlur, errors, touched, isSubmitting, isValid }) => (
        <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          {/* CONCEPTO RECTIFIACION TOTAL */}
          <TextField
            fullWidth
            name="ConceptoRectificacionACero"
            label="Concepto rectificativa"
            value={values.ConceptoRectificacionTotal}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.ConceptoRectificacionTotal && Boolean(errors.ConceptoRectificacionTotal)}
            helperText={touched.ConceptoRectificacionTotal && (errors.ConceptoRectificacionTotal as string)}
            sx={{ mb: 1 }}
            disabled={isSubmitting}
          />

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
            <Button
              style={{ marginRight: '20px', backgroundColor: '#F39868', color: '#fff', borderRadius: 7 }}
              onClick={() => toggleDialogClose()}>
              <Typography style={{ fontWeight: 'bold' }}>Cancelar</Typography>
            </Button>
            <LoadingButton
              variant="contained"
              type="submit"
              style={{ backgroundColor: '#E5824F', color: 'white', opacity: isValid && !isSubmitting ? '100%' : '80%' }}
              disabled={isSubmitting || !isValid}
              loading={isSubmitting}>
              Generar
            </LoadingButton>
          </Box>
        </Form>
      )}
    </Formik>
  );
};
